export const SET_ITEMS = 'TREE_SET_ITEMS';
export const ADD_ITEM = 'TREE_ADD_ITEM';
export const REMOVE_ITEM = 'TREE_REMOVE_ITEM';
export const TOGGLE_ITEM = 'TREE_TOGGLE_ITEM';
export const SET_SELECTED_ITEMS = 'TREE_SET_SELECTED_ITEMS';
export const TOGGLE_ITEM_SELECTION = 'TREE_TOGGLE_ITEM_SELECTION';
export const REMOVE_ITEM_SELECTION = 'TREE_REMOVE_ITEM_SELECTION';
export const FIX_SELECTION = 'TREE_FIX_SELECTION';

export function setItems(items, resource, elementId) {
    return {
        type: SET_ITEMS,
        elementId,
        resource,
        payload: items,
    };
}

export function addItem(item, resource, elementId) {
    return {
        type: ADD_ITEM,
        elementId,
        resource,
        payload: item,
    };
}

export function removeItem(item, resource, elementId) {
    return {
        type: REMOVE_ITEM,
        elementId,
        resource,
        payload: item,
    };
}

export function toggleItem(item, resource, elementId) {
    return {
        type: TOGGLE_ITEM,
        elementId,
        resource,
        payload: item,
    };
}

export function setSelectedItems(selectedItems, resource, elementId) {
    return {
        type: SET_SELECTED_ITEMS,
        elementId,
        resource,
        payload: selectedItems,
    };
}

export function toggleItemSelection(item, resource, elementId) {
    return {
        type: TOGGLE_ITEM_SELECTION,
        elementId,
        resource,
        payload: item,
    };
}

export function removeItemSelection(id, resource, elementId) {
    return {
        type: REMOVE_ITEM_SELECTION,
        elementId,
        resource,
        payload: id,
    };
}

export function fixSelection(resource, elementId) {
    return {
        type: FIX_SELECTION,
        elementId,
        resource,
    };
}
